const state = {
  selectedChat: null,
  chats: [],
};

const mutations = {
  setSelectedChat(state, chat) {
    state.selectedChat = chat;
  },
  setChats(state, chats) {
    state.chats = chats;
  },
};


import { fetchConversations } from '@/service/silvia/Requests.js';

const actions = {
  async loadChats({ commit }) {
    const chats = await fetchConversations();
    commit('setChats', chats);
  },
  selectChat({ commit }, chat) {
    commit('setSelectedChat', chat);
  },
};


const getters = {
  selectedChat: (state) => state.selectedChat,
  chats: (state) => state.chats,
};


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
